import { locale } from "./locale"

/**
 * @template T
 * @param {T[]} arr
 * @param {T} val
 */
function binarySearchInsert(arr, val) {
    let low = 0
    let high = arr.length
    while (low < high) {
        const i = Math.floor((low + high) / 2)
        if (arr[i] < val) low = i + 1
        else high = i
    }
    arr.splice(low, 0, val)
}

/**
 * @template T
 * @param {T[]} arr
 * @param {T} val
 */
function binarySearchRemove(arr, val) {
    let low = 0
    let high = arr.length
    while (low < high) {
        const i = Math.floor((low + high) / 2)
        if (arr[i] < val) low = i + 1
        else if (arr[i] > val) high = i
        else return arr.splice(i, 1)
    }
}

/**
 * @param {Blob} blob
 * @param {string} filename
 * @returns {Promise<File>}
 */
function blobToFile(blob, filename) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
            if (reader.readyState !== FileReader.DONE) {
                reject()
                return
            }

            if (!(reader.result instanceof ArrayBuffer)) {
                reject()
                return
            }

            const fileType = getFileType(reader.result)
            const file = new File([blob], filename + fileType)
            resolve(file)
        }
        reader.onerror = reject
        reader.readAsArrayBuffer(blob)
    })
}

/**
 * @param {number} ms
 */
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * @param {File} file 
 */
function download(file) {
    // setup
    const url = URL.createObjectURL(file)
    const a = document.createElement("a")
    a.href = url
    a.download = file.name

    // download
    document.body.appendChild(a)
    a.click()

    // cleanup
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}

/**
 * @param {number} amount
 */
function formatDataAmount(amount) {
    const units = ["B", "KB", "MB", "GB"]

    let i = 0
    for (; amount > 999; amount /= 1e3) i++

    return `${parseFloat(amount.toFixed(2))} ${units[i]}`
    // return `${amount.toPrecision(3)} ${units[i]}`
}

/**
 * @param {ArrayBuffer} buffer 
 */
function getFileType(buffer) {
    const bytes = new Uint8Array(buffer)
    if (bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF) return '.jpg'
    if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) return '.png'
    if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) return '.pdf'
    return ""
}

/**
 * @param {number} i 
 * @returns {string}
 */
function indexToWeekday(i) {
    switch (i % 7) {
        case 0:
            return locale.strings.sunday
        case 1:
            return locale.strings.monday
        case 2:
            return locale.strings.tuesday
        case 3:
            return locale.strings.wednesday
        case 4:
            return locale.strings.thursday
        case 5:
            return locale.strings.friday
        case 6:
            return locale.strings.saturday
        default:
            throw `invalid index: ${i}`
    }
}

/**
 * @param {Object | undefined} params
 */
function objectToQueryString(params) {
    if (!params || typeof params !== "object") return ""
    return Object.entries(params)
        .filter(([key, value]) => value)
        .reduce(
            (acc, [key, value]) => `${acc}${acc.length > 0 ? '&' : '?'}${key}=${value}`,
            ""
        )
}

export {
    binarySearchInsert,
    binarySearchRemove,
    blobToFile,
    delay,
    download,
    formatDataAmount,
    indexToWeekday,
    objectToQueryString,
}